<template>
	<div id="">
	<Row>
	    <Col span="14">
			<div id="Mimelist" style="width: 600px;height: 600px;"></div>
		</Col>
	    <Col span="8">
			<div style=" margin-top: 20px;margin-bottom: 60px;">
				<Table  border :columns="columns" :data="datas"  ref="table">
					<template slot-scope="{ index,row }"  slot="clueNums">
						<span  style="color:#63B3E6;cursor: pointer;" @click.stop="goToClickClientByclueNums">{{row.clueNums}}</span>
					</template>
				</Table>
			</div>
		</Col>
	</Row>
	<Row  justify="center">
		<Col span="24" style="padding-left: 43%;">
			<span style="font-size: 20px;font-weight: 600;">{{displayName}}历史数据图</span>
		</Col>
	</Row>		
	</div>

</template>

<script>
	import {mapGetters} from "vuex";
	import {getDepartmentStaticData} from "../../api/statics";
	export default {
		name: 'HistoryCreateMoney',
		props: ['userId','jumpType','departmentId','displayName'],
		data() {
			return {
				columns: [
					{
					    "title": "月份",
					    "key": "name",
						"align":"center",
					},
				    {
				        "title": "客户数",
				        "key": "clueNums",
						"align":"center",
				    },
				    {
				        "title": "上门数/上门率",
				        "key": "visitNums",
						"align":"center",
				    }, 
				    {
				        "title": "签约数/签约率",
				        "key": "signNums",
						"align":"center",
				    },
					{
					    "title": "放款数/放款率",
					    "key": "loanNums",
						"align":"center",
					},
					{
					    "title": "邀约业绩",
					    "key": "invate_money",
						"align":"center",
					},
					{
					    "title": "谈单业绩",
					    "key": "assist_money",
						"align":"center",
					},
					{
					    "title": "创收",
					    "key": "distribute",
						"align":"center",
					}, 
				],
                optionRight: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    legend: {
                        data: ['客户(条)', '上门客户(个)', '签约(笔)', '业绩(元)', '放款(元)'],
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: [],
                            axisPointer: {
                                type: 'shadow'
                            },
                            axisTick: { //x轴刻度线
                                show: true
                            },
                            axisLine: { //x轴
                                show: true
                            },
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            min: 0,
                            splitLine: {show: false},
                            axisTick: { //y轴刻度线
                                show: true
                            },
                            axisLine: { //y轴
                                show: true
                            },
                        },
                        {
                            type: 'value',
                            min: 0,
                            splitLine: {show: false},
                            axisTick: { //y轴刻度线
                                show: true
                            },
                            axisLine: { //y轴
                                show: true
                            },
                        }
                    ],
                    series: [
                        {
                            name: '客户(条)',
                            type: 'bar',
                            data: [],
                            color: '#0092FF',
                            barGap: '0',
                        },
                        {
                            name: '上门客户(个)',
                            type: 'bar',
                            data: [],
                            color: '#9F6DE5'
                        },
                        {
                            name: '签约(笔)',
                            type: 'bar',
                            data: [],
                            color: '#79CD75'
                        },
						{
						    name: '放款数',
						    type: 'bar',
						    data: [],
						    color: '#FFAF74'
						},
                        {
                            name: '业绩(元)',
                            type: 'line',
                            yAxisIndex: 1,
                            data: [],
                            color: '#FF3434'
                        },
                    ],
					myChart: null,
					myChart2: null,
                },
				datas:[],
				categoryType:'month',
				
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		watch: {
			userId() {
				this.getList();
			},
			departmentId(){
				this.getList();
			}
		},
		mounted() {
			this.myChart = this.$echarts.init(document.getElementById("Mimelist"));
			this.getList();
		},
		methods: {
			async getList() {
				let that = this;
				let data = {
					categoryType: this.categoryType,
					userId:this.userId,
					token:this.token,
					jumpType:this.jumpType,
					departmentId:this.departmentId,
				}
				let res = await getDepartmentStaticData(that, data);
				that.optionRight.xAxis[0]['data'] = res.data.xAxis;
				that.optionRight.series[0]['data'] = res.data.series['clueNums'];
				that.optionRight.series[1]['data'] = res.data.series['visitNums'];
				that.optionRight.series[2]['data'] = res.data.series['signNums'];
				that.optionRight.series[3]['data'] = res.data.series['loanNums'];
				that.optionRight.series[4]['data'] = res.data.series['distribute'];
				
				let series = that.optionRight.series;
				that.datas = res.data.list
				//创建echarts对象
				this.myChart.setOption(that.optionRight);
			},
			goToClickClientByclueNums(){
				this.$router.push({
				    name: 'shop_client',
				    params: {
						data:this.datas
				    }
				})
			},
		}
	}
</script>

<style>
</style>
